var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoveOven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.978,
    height: 23.608,
    viewBox: "0 0 17.978 23.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(-985.637 -2039.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(195.586 -180.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    d: "M1,0H15.478a1,1,0,0,1,1,1V22.108a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(790.801 2220.188)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 11.426,
    height: 11.065,
    transform: "translate(793.207 2228.584)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M111.238,634.978v1.127h6.67v-1.127",
    transform: "translate(684.466 1595.635)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x2: 16.478,
    transform: "translate(790.801 2226.009)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(179.586 -167.296)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 1.124,
    cy: 1.124,
    rx: 1.124,
    ry: 1.124,
    transform: "translate(810.595 2211.854) rotate(-121)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 1.124,
    cy: 1.124,
    rx: 1.124,
    ry: 1.124,
    transform: "translate(814.595 2211.854) rotate(-121)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 1.124,
    cy: 1.124,
    rx: 1.124,
    ry: 1.124,
    transform: "translate(818.595 2211.854) rotate(-121)",
    fill: "#005682"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoveOven);
export default __webpack_public_path__ + "static/media/stove-oven.c2415f45408d4bdc17466fa94e4cdd74.svg";
export { ForwardRef as ReactComponent };